export const DATE_FORMAT_CLIENT = "dd MMM, yyyy";
export const DATE_TIME_FORMAT_CLIENT = "dd MMM, yyyy hh:mm:ss";
export const DATE_FORMAT_API = "yyyy-MM-dd";
export const DATE_TIME_FORMAT_API = "yyyy-MM-dd hh:mm:ss";

export const NEW_DATE_TIME_FORMAT = "dd.MM.yyyy hh:mm:ss a";
export const GERMAN_DATE_FORMAT = "MM/DD/YYYY";
export const TIME_ZONE = "Europe/Rome";
